<template>
  <div class="input-label" :class="{disabled}" @click="focusOnInput">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InputLabel',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    for: {
      type: HTMLInputElement,
      default: null
    }
  },
  methods: {
    focusOnInput() {
      if (this.for) {
        this.for.focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.input-label {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 8px;

  &.disabled {
    color: $gray-2;
  }
}
</style>
